import {
  type DesktopOperatingSystem,
  OperatingSystem,
} from "../types/operating-system.ts";

export function detectBrowserDesktopOs(): DesktopOperatingSystem | null {
  // Typed structurally because backend compiles this module without DOM types.
  const nav: { userAgent: string; maxTouchPoints?: number } | undefined =
    typeof navigator === "undefined" ? undefined : navigator;
  if (!nav) return null;
  if (/android|iphone|ipad|ipod|cros/i.test(nav.userAgent)) return null;
  // iPadOS Safari masquerades as macOS; multi-touch gives it away.
  if (/macintosh/i.test(nav.userAgent) && (nav.maxTouchPoints ?? 0) > 1) {
    return null;
  }
  if (/windows nt/i.test(nav.userAgent)) return OperatingSystem.Windows;
  if (/macintosh/i.test(nav.userAgent)) return OperatingSystem.MacOS;
  if (/x11|linux/i.test(nav.userAgent)) return OperatingSystem.Linux;
  return null;
}

export function isDesktopBrowser(): boolean {
  return detectBrowserDesktopOs() !== null;
}
